import React from "react";
import NotFoundSection from "../components/elements/NotFoundSection";
import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";
const NotFound = () => {
  return (
    <>
      <Header />
      <NotFoundSection />
      <Footer />
    </>
  );
};

export default NotFound;
